export default "__VITE_ASSET__DBQlK15S__"